import { getCachedSession } from '@/features/auth/utils/sessionCache';
import logger from '@/utils/logger';
import { isDevelopment } from '@/utils/util';
import axios from 'axios';
import { generateHeaders, getCommonHeaders } from './headers';

export const apiClient = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
  timeout: 1000 * 60 * 10, // 10분 FIXME: 검색 결과 호출 시 타임아웃 늘렸음. 추후 조정 필요
  headers: getCommonHeaders(),
});

apiClient.interceptors.request.use(async (config) => {
  try {
    // 캐싱된 세션 정보 사용
    const session = await getCachedSession();

    if (session?.user?.accessToken) {
      config.headers.Authorization = `Bearer ${session.user.accessToken}`;
    } else {
      delete config.headers.Authorization;
    }

    Object.assign(config.headers, generateHeaders());

    if (isDevelopment()) {
      const url = config.url ?? decodeURIComponent(config.url ?? '');
      logger.info(`➡️ Request: ${config.method?.toUpperCase()} ${url}`);
      if (config.data) {
        logger.info(config.data);
      }
    }
    return config;
  } catch (error) {
    logger.error('Session retrieval error:', error);
    return config;
  }
});

apiClient.interceptors.response.use(
  (response) => {
    if (isDevelopment()) {
      logger.info('✅ Response: ', response.status, response.config.url);
      logger.info(response.data);
    }
    return response;
  },
  async (error) => {
    return Promise.reject(error);
  },
);

export default apiClient;
